import '../../stylesheets/recovery/page';
//---------app/views/accounts/recovery/inquire.html.slimに記載
//---------app/views/accounts/recovery/verify.html.slim